class VideoCover extends HTMLElement {
  connectedCallback() {
    const covers = this.querySelectorAll(".video-cover");
    const iframes = this.querySelectorAll(".js-youtube");
    covers.forEach((cover, index) => {
      cover.addEventListener("click", function clickHandler() {
        cover.classList.add("hidden");
        const iframe = iframes[index];
        let iframeSrc = iframe.src;
        if (!iframeSrc.includes("autoplay=1")) {
          iframe.src = iframeSrc + (iframeSrc.includes('?') ? '&' : '?') + "autoplay=1";
        }
        cover.removeEventListener("click", clickHandler);
      });
    });
  }
}

customElements.define('video-cover', VideoCover);